import { Camelized } from 'humps';
import { baseFetchTool } from './base';
import { OS, query } from '@/modules/util';

export const DEFAULT_LIST_SIZE = 30;


// 获取用户订单，端调用
export const getOrders = (
  start: number,
  successCallback: (arg0: Camelized<any>) => void,
  errorCallback: (arg0: any) => void,
) => {
  const appid = query('appid');
  const scene = query('scene');
  baseFetchTool(
    'GetOrders',
    {
      start: start * DEFAULT_LIST_SIZE,
      size: DEFAULT_LIST_SIZE,
      appid,
      scene,
      platform: OS(),
    },
    successCallback,
    errorCallback,
  );
};

